import * as React from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { UserList } from '@/components/users'
import { AddUserComposer, InviteUserComposer } from '@/forms/users'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useToast } from '@/contexts/ToastContext'

// 'add' creates an active user now; 'invite' sends an invitation (user created on accept).
type View = 'list' | 'add' | 'invite'

function UsersPage() {
  const { toast } = useToast()
  const navigate = useNavigate()
  const [view, setView] = React.useState<View>('list')
  const [listKey, setListKey] = React.useState(0)

  const backToList = () => setView('list')

  const handleAddSuccess = () => {
    toast({ title: 'Success', description: 'User created.', type: 'success' })
    setListKey((k) => k + 1)
    setView('list')
  }

  if (view !== 'list') {
    return (
      <div className="p-6 space-y-4">
        <Button variant="ghost" className="gap-2" onClick={backToList}>
          <ArrowLeft className="h-4 w-4" />
          Back to Users
        </Button>
        {view === 'add' ? (
          <AddUserComposer
            onSuccess={handleAddSuccess}
            onError={(error) => toast({ title: 'Error', description: error.message, type: 'error' })}
            onCancel={backToList}
          />
        ) : (
          // InviteUserComposer shows its own "Invitation sent to …" toast; land on the invitations page.
          <InviteUserComposer onSuccess={() => navigate({ to: '/invitations' })} onCancel={backToList} />
        )}
      </div>
    )
  }

  return (
    <div className="p-6">
      <UserList key={listKey} onAdd={() => setView('add')} onInvite={() => setView('invite')} />
    </div>
  )
}

export const Route = createFileRoute("/users/")({
  staticData: {
    title: 'Users',
    isSecured: true,
  },
  component: UsersPage,
})
